import React from 'react';
import { LinkPreview } from './LinkPreview';

interface AccordionContentViewProps {
  url: string;
  title: string;
}

export const AccordionContentView: React.FC<AccordionContentViewProps> = ({ url, title }) => {
  return (
    <div className="relative" style={{ height: '400px' }}>
      <LinkPreview url={url} title={title} />
    </div>
  );
};
